document.addEventListener('DOMContentLoaded', () => {
    const productHandle = window.location.pathname.split('/').pop();
    addRecentlyViewedProduct(productHandle);

    const recentlyViewed = getRecentlyViewedProducts();

    const targetElementContainer = document.querySelector('.recently-viewed-grid');
    targetElementContainer.innerHTML = '';
    recentlyViewed.forEach(handle => {
        // console.log(handle);
        async function fetchAndInjectHTML(url, targetElementSelector) {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const html = await response.text();
                const targetElement = document.querySelector(targetElementSelector);
                if (targetElement) {
                    targetElement.innerHTML += html;
                    reloadCustomScript();
                } else {
                    console.error("Target element not found!");
                }
            } catch (error) {
                console.error("Error fetching HTML:", error);
            }
        }
        const url = `/products/${handle}?view=recent-view`;
        const targetSelector = '.recently-viewed-grid';
        fetchAndInjectHTML(url, targetSelector);
    });
});

// Function to add product handle to localStorage
function addRecentlyViewedProduct(handle) {
    const localStorageKey = 'recentlyViewedProducts';
    const maxItems = 4;

    let recentlyViewed = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    recentlyViewed = recentlyViewed.filter(item => item !== handle);
    recentlyViewed.unshift(handle);

    if (recentlyViewed.length > maxItems) {
        recentlyViewed.pop();
    }

    // Update localStorage
    localStorage.setItem(localStorageKey, JSON.stringify(recentlyViewed));
}

// Function to get the recently viewed products from localStorage
function getRecentlyViewedProducts() {
    const localStorageKey = 'recentlyViewedProducts';
    return JSON.parse(localStorage.getItem(localStorageKey)) || [];
}

function reloadCustomScript() {
    const oldScript = document.querySelector('script[src*="custom.js"]');
    // console.log('oldScript',oldScript);
    if (oldScript) oldScript.remove();

    const newScript = document.createElement('script');
    newScript.src = "//lidsmarketplace.com/cdn/shop/t/6/assets/custom.js?v=56001569024920936341731669753";
    newScript.defer = true;
    document.body.appendChild(newScript);
}